"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../data/constants");
var abstractComponent_1 = __importDefault(require("./abstractComponent"));
var SolrInput = /** @class */ (function (_super) {
    __extends(SolrInput, _super);
    function SolrInput() {
        var _this = _super.call(this, constants_1.DATA_SOLR_INPUT) || this;
        if (!_this.getElement()) {
            return _this;
        }
        _this.dataSolrInput = _this.getElement();
        _this.dataSolrInputField = _this.getChildElement("[".concat(constants_1.DATA_SOLR_INPUT_FIELD, "]"));
        _this.dataSolrBtnSearch = _this.getChildElement("[".concat(constants_1.DATA_SOLR_BTN_SEARCH, "]"));
        _this.dataSolrBtnClear = _this.getChildElement("[".concat(constants_1.DATA_SOLR_BTN_CLEAR, "]"));
        _this.checkSolrInput(_this.dataSolrInputField);
        _this.dataSolrInputField.addEventListener('change', function () {
            _this.checkSolrInput(_this.dataSolrInputField);
        });
        _this.dataSolrBtnClear.addEventListener('click', function () {
            _this.clearSolrInput();
        });
        return _this;
    }
    SolrInput.prototype.checkSolrInput = function (element) {
        if (element.value) {
            element.classList.add('filled');
            this.dataSolrBtnClear.classList.add('active');
        }
        else {
            this.dataSolrBtnClear.classList.remove('active');
        }
    };
    SolrInput.prototype.clearSolrInput = function () {
        this.dataSolrInputField.value = '';
        this.dataSolrInputField.classList.remove('filled');
        this.checkSolrInput(this.dataSolrInputField);
    };
    return SolrInput;
}(abstractComponent_1.default));
exports.default = SolrInput;
